import imagesLoaded from "imagesloaded";

export const speedboaFrameByFrame = () => {
    const framesContainer = document.querySelector('#frames-container');
    const frameByFrame = document.querySelector('#frame-by-frame');
    const canvas = document.getElementById("frame-by-frame-canvas");
    if (framesContainer && frameByFrame && canvas) {
        gsap.registerPlugin(ScrollTrigger);
        let currentFrame;
        canvas.width = 1920;
        canvas.height = 1080;
        let completed = 0;
        let format = 'webp';
        let device = 'desktop';
        if (window.matchMedia('(max-width: 991px)').matches) {
            device = 'mobile';
            canvas.width = 1080;
            canvas.height = 1920;
        }
        ScrollTrigger.matchMedia({
            "all": function () {
                currentFrame = index => (
                    `/assets/images/speedboa-${device}-fbf/frame-${(index).toString().padStart(4, '0')}.${format}`
                );
                const context = canvas.getContext("2d");
                const frameCount = 693;
                const images = [];
                const frames = {
                    frame: 0
                };
                for (let i = 0; i < frameCount; i++) {
                    let img = new Image();
                    img.src = currentFrame(i);
                    // img.classList.add('img-fluid');
                    framesContainer.append(img);
                    images.push(img);
                }
                let imgLoad = imagesLoaded(images, {background: true});
                imgLoad.on('progress', function (instance, image) {
                    completed = completed + 1;
                    if (completed === (frameCount - 1)) {
                        render();
                        document.body.classList.add('fbf-loaded');
                    }
                });

                // Step 1
                gsap.to(frames, {
                    frame: 238,
                    snap: "frame",
                    scrollTrigger: {
                        scrub: .5,
                        trigger: '.frame-by-frame__trigger',
                        endTrigger: '.frame-by-frame__end-trigger',
                        start: 'top 100%',
                        end: "+=2200",
                        markers: false,
                    },
                    onUpdate: render,
                    immediateRender: false,
                });
                // Step 2
                gsap.to(frames, {
                    frame: 329,
                    snap: "frame",
                    scrollTrigger: {
                        scrub: .5,
                        trigger: '.frame-by-frame__trigger',
                        endTrigger: '.frame-by-frame__end-trigger',
                        start: 'top+=1440px top',
                        end: "+=2200",
                    },
                    onUpdate: render,
                    immediateRender: false,
                });
                // Step 3
                gsap.to(frames, {
                    frame: 600,
                    snap: "frame",
                    scrollTrigger: {
                        scrub: .5,
                        trigger: '.frame-by-frame__trigger',
                        endTrigger: '.frame-by-frame__end-trigger',
                        start: 'top+=2880px top',
                        end: "+=2200",
                    },
                    onUpdate: render,
                    immediateRender: false,
                });
                gsap.to(frames, {
                    frame: 692,
                    snap: "frame",
                    scrollTrigger: {
                        scrub: .5,
                        trigger: '.frame-by-frame__trigger',
                        endTrigger: '.frame-by-frame__end-trigger',
                        start: 'top+=4320px top',
                        end: "+=2200",
                    },
                    onUpdate: render,
                    immediateRender: false,
                });

                function render() {
                    context.clearRect(0, 0, canvas.width, canvas.height);
                    context.drawImage(images[frames.frame], 0, 0);
                }

                /**
                 *  FRAMES
                 */
                // Frame 1
                ScrollTrigger.create({
                    trigger: '.frame-by-frame__trigger',
                    start: 'top+=1200 100%',
                    end: "+=960",
                    markers: false,
                    onToggle: self => {
                        const frame1 = document.querySelector('.frame--1');
                        if (self.isActive) {
                            frame1.classList.add('active');
                        } else {
                            frame1.classList.remove('active');
                        }
                    },
                });
                // Frame 2
                ScrollTrigger.create({
                    trigger: '.frame-by-frame__trigger',
                    start: 'top+=1800 top',
                    end: "+=960",
                    markers: false,
                    onToggle: self => {
                        const frame2 = document.querySelector('.frame--2');
                        if (self.isActive) {
                            frame2.classList.add('active');
                        } else {
                            frame2.classList.remove('active');
                        }
                    },
                });
                // Frame 3
                ScrollTrigger.create({
                    trigger: '.frame-by-frame__trigger',
                    start: 'top+=3700 top',
                    end: "+=600",
                    onToggle: self => {
                        const frame3 = document.querySelector('.frame--3');
                        if (self.isActive) {
                            frame3.classList.add('active');
                        } else {
                            frame3.classList.remove('active');
                        }
                    },
                });

                /**
                 *  Frame by frame PIN
                 */
                ScrollTrigger.create({
                    trigger: '.frame-by-frame__trigger',
                    endTrigger: ".frame-by-frame__end-trigger",
                    pin: '.frame-by-frame__pin',
                    pinSpacing: false,
                    markers: false,
                    start: "top 100%",
                    end: "top+=2200",
                });
            }
        })
    }
}
